import * as React from 'react';

function SvgStickShift24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={26}
      fill='none'
      viewBox='0 0 26 26'
      {...props}
    >
      <path
        d='M22.5999 5.80005V13H3.3999M12.9999 5.80005V20.2M3.3999 5.80005V20.2'
        stroke='black'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25 3.4C25 4.03652 24.7471 4.64697 24.2971 5.09706C23.847 5.54714 23.2365 5.8 22.6 5.8C21.9635 5.8 21.353 5.54714 20.9029 5.09706C20.4529 4.64697 20.2 4.03652 20.2 3.4C20.2 2.76348 20.4529 2.15303 20.9029 1.70294C21.353 1.25286 21.9635 1 22.6 1C23.2365 1 23.847 1.25286 24.2971 1.70294C24.7471 2.15303 25 2.76348 25 3.4V3.4ZM15.4 3.4C15.4 4.03652 15.1471 4.64697 14.6971 5.09706C14.247 5.54714 13.6365 5.8 13 5.8C12.3635 5.8 11.753 5.54714 11.3029 5.09706C10.8529 4.64697 10.6 4.03652 10.6 3.4C10.6 2.76348 10.8529 2.15303 11.3029 1.70294C11.753 1.25286 12.3635 1 13 1C13.6365 1 14.247 1.25286 14.6971 1.70294C15.1471 2.15303 15.4 2.76348 15.4 3.4V3.4ZM5.8 3.4C5.8 4.03652 5.54714 4.64697 5.09706 5.09706C4.64697 5.54714 4.03652 5.8 3.4 5.8C2.76348 5.8 2.15303 5.54714 1.70294 5.09706C1.25286 4.64697 1 4.03652 1 3.4C1 2.76348 1.25286 2.15303 1.70294 1.70294C2.15303 1.25286 2.76348 1 3.4 1C4.03652 1 4.64697 1.25286 5.09706 1.70294C5.54714 2.15303 5.8 2.76348 5.8 3.4V3.4ZM15.4 22.6C15.4 23.2365 15.1471 23.847 14.6971 24.2971C14.247 24.7471 13.6365 25 13 25C12.3635 25 11.753 24.7471 11.3029 24.2971C10.8529 23.847 10.6 23.2365 10.6 22.6C10.6 21.9635 10.8529 21.353 11.3029 20.9029C11.753 20.4529 12.3635 20.2 13 20.2C13.6365 20.2 14.247 20.4529 14.6971 20.9029C15.1471 21.353 15.4 21.9635 15.4 22.6V22.6ZM5.8 22.6C5.8 23.2365 5.54714 23.847 5.09706 24.2971C4.64697 24.7471 4.03652 25 3.4 25C2.76348 25 2.15303 24.7471 1.70294 24.2971C1.25286 23.847 1 23.2365 1 22.6C1 21.9635 1.25286 21.353 1.70294 20.9029C2.15303 20.4529 2.76348 20.2 3.4 20.2C4.03652 20.2 4.64697 20.4529 5.09706 20.9029C5.54714 21.353 5.8 21.9635 5.8 22.6V22.6Z'
        stroke='black'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M22.6002 25C23.9257 25 25.0002 23.9254 25.0002 22.6C25.0002 21.2745 23.9257 20.2 22.6002 20.2C21.2747 20.2 20.2002 21.2745 20.2002 22.6C20.2002 23.9254 21.2747 25 22.6002 25Z'
        stroke='black'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default SvgStickShift24;
